<template>
	<div>
		<Card>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">账号密码修改</span>
					</div>
				</div>
				</Col>
			</Row>
			<Row :gutter="16" style="margin-top:10px;margin-left:10px;">
				<Form label-position="top">
					<Col span="5">
					<FormItem label="输入账号/姓名搜索">
						<Input v-model="searchKeyValue" placeholder="请输入用户账号或者姓名" style="width:310px;"></Input>
						<Button type="primary"
							style="margin-left: 5px;"
							@click="searchUserInfoByKeyValue">搜索</Button>
					</FormItem>
					</Col>
					<Col span="4" v-if="isSearch">
					<FormItem label="账号信息">
						<Select v-model="userUuid"
							filterable
							style="width:320px;">
							<Option v-for="item in userList"
								:key="item.userUuid"
								:value="item.userUuid">{{ item.userName + '-' +item.userPersonName + '-' + item.userPhone }}</Option>
						</Select>
					</FormItem>
					</Col>
				</Form>
			</Row>
			<Row :gutter="16" style="margin-left:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem label="新密码">
						<Input v-model="newPassword"
						    size="small"
						    style="width:320px;"></Input>
					</FormItem>
					</Col>
				</Form>
			</Row>
			<Row :gutter="16" style="margin-left:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem label="确认密码">
						<Input v-model="confirmPassword"
						    size="small"
						    style="width:320px;"></Input>
					</FormItem>
					</Col>
				</Form>
			</Row>
			<Row :gutter="16" style="margin-left:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem>
						<Button type="success" @click="updatePassword()">保存</Button>
					</FormItem>
					</Col>
				</Form>
			</Row>
		</Card>
	</div>
</template>

<script>
import { systemUpdatePassword } from '@/api/modules/system-management/system-setting';
import { getUserListByKey } from '@/api/modules/system-management/seedFarm-management';
export default {
    name: 'systemUpdatePassword',
    components: {},
    data() {
        return {
            searchKeyValue:'',
            isSearch:false,
            userList:[],
            userUuid:'',
            newPassword:'',
            confirmPassword:''
        };
    },
    mounted() {
    },
    methods: {

        searchUserInfoByKeyValue(){
            if(!this.searchKeyValue){
                this.$Message.info({ title: '提示', content: '请输入用户账号或者姓名！' });
                return;
            }
            this.isSearch=true;
            let keyValue=this.searchKeyValue;
            this.getUserList(keyValue);
        },
        getUserList(keyValueStr) {
				    getUserListByKey({ keyValue:keyValueStr }).then(res => {
				        if (res.code === 0) {
				            this.userList = res.data.allTypeUserList;
				        }
				    });
        },
        updatePassword(){
            systemUpdatePassword({ userUuid:this.userUuid, newPassword:this.newPassword, confirmPassword:this.confirmPassword }).then(res => {
					    if (res.code === 0) {
					        this.$Message.success('密码修改成功！');
					    }
            });
        }
    }
};
</script>

<style>
</style>
